var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12984",
    "data-name": "Group 12984",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194.433,
    height: 185.831,
    viewBox: "0 0 194.433 185.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6575",
    "data-name": "Rectangle 6575",
    width: 194.433,
    height: 185.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23586",
    "data-name": "Path 23586",
    d: "M103.283,36.466c-30.6,37.2-35.527,100.4-3.558,130.631,16.647,15.742,37.967,17.507,48.563,18.384,38.808,3.212,88.34-15.626,107.1-59.485,11.726-27.407,10.348-61.623-5.325-86.132A85.678,85.678,0,0,0,232.64,20.091C229.984,17.9,208.138.319,177.015,0c-.283,0-.564,0-.845,0C134.143,0,107.2,31.707,103.283,36.466",
    transform: "translate(-77.932)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.155,
    y1: 0.834,
    x2: 0.155,
    y2: 0.834,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6560",
    "data-name": "Rectangle 6560",
    width: 194.432,
    height: 185.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23606",
    "data-name": "Path 23606",
    d: "M330.124,300.851c-.64.613.8.677,7.645,9.466l.909,1.151c8.833,11.69,17.374,25.473,21.2,39.688a96.4,96.4,0,0,1,2.232,34.718.713.713,0,0,0,.563.808.7.7,0,0,0,.822-.56,87.074,87.074,0,0,0,.67-23.775,78.1,78.1,0,0,0-4.325-18.9c-6.486-16.61-18.654-33.219-29.177-42.6a.4.4,0,0,0-.541.01",
    transform: "translate(-329.987 -300.741)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.073,
    y1: 2.124,
    x2: 0.074,
    y2: 2.124,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23609",
    "data-name": "Path 23609",
    d: "M281.645,1774.44c6.618,11.493,25.948,4.169,24.986-5.449s-23.545-49.376-23.545-49.376l-25.189-2.671s18.047,47.6,23.748,57.5",
    transform: "translate(-257.897 -1716.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23610",
    "data-name": "Path 23610",
    d: "M582.186,647.462l-3.065,40.9,114.054,25.448,1.178-105.242Z",
    transform: "translate(-579.121 -608.572)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.132,
    y1: 1.127,
    x2: -0.132,
    y2: 1.127,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23611",
    "data-name": "Path 23611",
    d: "M2150.929,645.2c0,29.87,4.934,54.085,11.02,54.085s11.02-24.215,11.02-54.085-4.934-54.085-11.02-54.085-11.02,24.215-11.02,54.085",
    transform: "translate(-2150.929 -591.12)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2.204,
    y1: 1.346,
    x2: -2.203,
    y2: 1.346,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23612",
    "data-name": "Path 23612",
    d: "M2214.627,652.672a229.536,229.536,0,0,0,0,71.332c1.86,10.1,4.03,14.013,5.026,15.026,1-1.013,3.166-4.921,5.026-15.026a229.536,229.536,0,0,0,0-71.332c-1.86-10.105-4.03-14.013-5.026-15.026-1,1.013-3.166,4.921-5.026,15.026",
    transform: "translate(-2211.839 -637.646)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -8.755,
    y1: 1.414,
    x2: -8.751,
    y2: 1.414,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23613",
    "data-name": "Path 23613",
    d: "M2212.324,1145.89c-.32,5.069-.485,10.393-.485,15.813,0,5.127.148,10.167.435,14.988a18.713,18.713,0,0,0,6.755,1.249c9.8,0,14.748-7.45,14.748-16.639s-4.95-16.639-14.748-16.639a18.714,18.714,0,0,0-6.7,1.229",
    transform: "translate(-2211.839 -1144.661)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23614",
    "data-name": "Path 23614",
    d: "M207.561,1154.289a11.066,11.066,0,0,0-9.668,9.326c-1.5,9.833-.093,22.075,1.057,29.359a7.478,7.478,0,0,0,7.39,6.306h23.075c-3.117-15.2-3.524-29.871-.829-43.95a60.384,60.384,0,0,0-13.447-1.479,65.919,65.919,0,0,0-7.577.439",
    transform: "translate(-197.242 -1153.85)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6569",
    "data-name": "Rectangle 6569",
    width: 85.879,
    height: 27.959,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6570",
    "data-name": "Rectangle 6570",
    width: 5.297,
    height: 2.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23624",
    "data-name": "Path 23624",
    d: "M2475.677,1652.92l-1.786,7.01,13.776,1.72-7.821-5.054,2.957-7.238-22.355-1.1Z",
    transform: "translate(-2460.449 -1648.262)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -6.668,
    y1: 2.801,
    x2: -6.665,
    y2: 2.801,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23625",
    "data-name": "Path 23625",
    d: "M2511.448,2164.547l-4.023,4.367,9.281,6.613-3.679-6.7,4.958-4.075-15.72-9.507Z",
    transform: "translate(-2502.265 -2155.245)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -6.662,
    y1: 1.776,
    x2: -6.659,
    y2: 1.776,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23626",
    "data-name": "Path 23626",
    d: "M2545.734,581.43l-5.042-5.51-10.078,18.858,10.243-11.249,5.325,4.406,10.912-17.177Z",
    transform: "translate(-2530.614 -570.759)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -4.594,
    y1: 4.378,
    x2: -4.592,
    y2: 4.378,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12983",
    "data-name": "Group 12983",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12950",
    "data-name": "Group 12950",
    transform: "translate(5.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12949",
    "data-name": "Group 12949",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6559",
    "data-name": "Rectangle 6559",
    width: 274.484,
    height: 273.908,
    transform: "matrix(0.734, -0.68, 0.68, 0.734, -104.248, 87.155)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12952",
    "data-name": "Group 12952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12951",
    "data-name": "Group 12951",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23587",
    "data-name": "Path 23587",
    d: "M822.783,1814.751a.233.233,0,0,1-.2-.355q.245-.4.5-.793a.233.233,0,0,1,.39.256q-.255.387-.5.781a.233.233,0,0,1-.2.111",
    transform: "translate(-767.959 -1693.139)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23588",
    "data-name": "Path 23588",
    d: "M910.438,1627.436a.234.234,0,0,1-.226-.175c-.149-.578-.317-1.159-.5-1.726a.233.233,0,0,1,.444-.143c.185.575.356,1.165.508,1.752a.233.233,0,0,1-.168.284.236.236,0,0,1-.059.007m-1.539-4.493a.233.233,0,0,1-.214-.141c-.237-.548-.493-1.1-.761-1.628a.233.233,0,0,1,.417-.21c.272.54.532,1.1.772,1.653a.234.234,0,0,1-.214.326m-2.214-4.2a.233.233,0,0,1-.2-.109c-.318-.5-.655-1.007-1-1.492a.233.233,0,1,1,.38-.271c.352.493.694,1,1.017,1.515a.233.233,0,0,1-.2.358m-50.273-2.915a.233.233,0,0,1-.182-.379c.38-.472.778-.939,1.185-1.387a.233.233,0,0,1,.346.314c-.4.442-.793.9-1.167,1.366a.232.232,0,0,1-.182.087m47.444-.9a.233.233,0,0,1-.176-.08c-.392-.453-.8-.9-1.215-1.324a.233.233,0,0,1,.334-.325c.42.432.836.884,1.234,1.343a.233.233,0,0,1-.176.386m-44.191-2.56a.233.233,0,0,1-.157-.406c.448-.408.913-.808,1.383-1.19a.233.233,0,0,1,.294.362c-.463.375-.922.77-1.363,1.172a.232.232,0,0,1-.157.061m40.817-.781a.232.232,0,0,1-.151-.055c-.457-.387-.929-.764-1.4-1.121a.233.233,0,1,1,.28-.373c.482.362.962.745,1.425,1.138a.233.233,0,0,1-.151.411m-37.074-2.145a.233.233,0,0,1-.13-.427c.5-.336,1.026-.662,1.548-.967a.233.233,0,0,1,.236.4c-.515.3-1.028.622-1.525.953a.234.234,0,0,1-.129.039m33.227-.637a.233.233,0,0,1-.121-.034c-.51-.311-1.034-.611-1.56-.891a.233.233,0,1,1,.219-.412c.534.284,1.067.589,1.584.9a.233.233,0,0,1-.122.433m-29.083-1.686a.233.233,0,0,1-.1-.445c.549-.254,1.114-.5,1.678-.718a.233.233,0,1,1,.171.434c-.556.219-1.112.456-1.653.707a.23.23,0,0,1-.1.022m24.853-.469a.234.234,0,0,1-.09-.018c-.549-.229-1.113-.444-1.678-.641a.233.233,0,1,1,.154-.441c.574.2,1.147.419,1.7.651a.233.233,0,0,1-.09.449m-20.4-1.187a.233.233,0,0,1-.064-.458c.582-.166,1.177-.318,1.769-.45a.233.233,0,1,1,.1.455c-.583.13-1.169.279-1.742.443a.232.232,0,0,1-.065.009m15.89-.294a.237.237,0,0,1-.056-.007c-.579-.142-1.17-.269-1.757-.377a.233.233,0,1,1,.084-.459c.6.11,1.2.239,1.784.382a.233.233,0,0,1-.055.46m-11.237-.656a.233.233,0,0,1-.029-.465c.6-.075,1.212-.133,1.816-.173a.233.233,0,1,1,.031.466c-.6.039-1.2.1-1.789.17l-.029,0m6.552-.119h-.021c-.593-.052-1.2-.087-1.794-.1a.233.233,0,0,1,.007-.466h.007c.606.018,1.219.053,1.821.106a.233.233,0,0,1-.02.466",
    transform: "translate(-799.356 -1497.379)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23589",
    "data-name": "Path 23589",
    d: "M1679.627,1997.548a.234.234,0,0,1-.231-.2q-.059-.459-.13-.916a.233.233,0,1,1,.461-.073q.074.464.133.93a.233.233,0,0,1-.2.261l-.03,0",
    transform: "translate(-1567.813 -1863.677)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23590",
    "data-name": "Path 23590",
    d: "M1585.779,2347.027a.233.233,0,0,1-.183-.378q.287-.364.561-.736a.233.233,0,0,1,.376.277q-.279.377-.57.748a.233.233,0,0,1-.184.089",
    transform: "translate(-1480.316 -2190.131)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23591",
    "data-name": "Path 23591",
    d: "M794.329,2192.011h0c-.636,0-1.281-.026-1.916-.068a.233.233,0,1,1,.03-.465c.626.041,1.262.063,1.888.066a.233.233,0,0,1,0,.467m3.089-.14a.233.233,0,0,1-.022-.466c.624-.059,1.255-.139,1.875-.237a.233.233,0,0,1,.073.461c-.629.1-1.27.181-1.9.241h-.022m-8.063-.284a.263.263,0,0,1-.039,0c-.629-.105-1.262-.231-1.881-.374a.233.233,0,1,1,.1-.455c.61.141,1.233.265,1.853.368a.233.233,0,0,1-.038.464m12.979-.591a.233.233,0,0,1-.059-.459c.607-.16,1.216-.341,1.812-.537a.233.233,0,1,1,.147.443c-.6.2-1.224.384-1.839.546a.24.24,0,0,1-.06.008m-17.821-.624a.228.228,0,0,1-.075-.012c-.6-.2-1.207-.429-1.8-.67a.233.233,0,1,1,.176-.432c.581.237,1.176.459,1.77.66a.233.233,0,0,1-.075.455m22.531-1.036a.233.233,0,0,1-.1-.446c.573-.256,1.145-.533,1.7-.824a.233.233,0,0,1,.216.414c-.564.3-1.145.577-1.727.837a.235.235,0,0,1-.095.02m-27.114-.942a.233.233,0,0,1-.109-.027c-.562-.3-1.121-.619-1.664-.952a.233.233,0,0,1,.244-.4c.534.328,1.086.644,1.639.938a.233.233,0,0,1-.11.439m31.492-1.459a.233.233,0,0,1-.128-.428c.523-.345,1.044-.711,1.547-1.088a.233.233,0,1,1,.28.373c-.51.383-1.039.754-1.57,1.1a.23.23,0,0,1-.128.039m-35.694-1.234a.232.232,0,0,1-.141-.048c-.506-.386-1.007-.793-1.488-1.209a.233.233,0,0,1,.305-.353c.474.41.967.811,1.466,1.191a.233.233,0,0,1-.142.419m39.633-1.838a.233.233,0,0,1-.158-.405c.462-.424.917-.867,1.353-1.319a.233.233,0,0,1,.336.324c-.442.458-.9.909-1.373,1.339a.232.232,0,0,1-.158.061m-43.344-1.5a.232.232,0,0,1-.169-.073c-.435-.46-.864-.942-1.274-1.433a.233.233,0,1,1,.358-.3c.4.483.827.958,1.255,1.412a.234.234,0,0,1-.17.394m-3.129-3.89a.233.233,0,0,1-.193-.1c-.359-.527-.706-1.072-1.03-1.618a.233.233,0,0,1,.4-.238c.32.538.661,1.074,1.015,1.594a.233.233,0,0,1-.193.365m-2.468-4.34a.233.233,0,0,1-.212-.135c-.269-.578-.523-1.171-.755-1.763a.233.233,0,1,1,.434-.17c.229.583.479,1.167.744,1.736a.233.233,0,0,1-.113.31.228.228,0,0,1-.1.022m-1.733-4.682a.233.233,0,0,1-.224-.171c-.172-.613-.326-1.24-.459-1.862a.233.233,0,1,1,.456-.1c.131.613.283,1.23.453,1.834a.234.234,0,0,1-.225.3",
    transform: "translate(-713.294 -2023.307)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23592",
    "data-name": "Path 23592",
    d: "M755.5,2108.384a.233.233,0,0,1-.232-.208q-.052-.467-.089-.935a.233.233,0,0,1,.214-.251.23.23,0,0,1,.251.214q.037.461.088.921a.233.233,0,0,1-.206.257H755.5",
    transform: "translate(-705.063 -1967.152)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23593",
    "data-name": "Path 23593",
    d: "M865.448,1733.206a.371.371,0,0,0,.194.385l4,2.1a19.664,19.664,0,0,0,1.516,6.188l-2.568,3.709a.371.371,0,0,0,.006.431l3.2,4.365a.371.371,0,0,0,.409.135l4.308-1.338a19.666,19.666,0,0,0,5.45,3.3l.808,4.441a.371.371,0,0,0,.309.3l5.352.821a.371.371,0,0,0,.385-.194l2.1-4a19.661,19.661,0,0,0,6.188-1.516l3.709,2.568a.371.371,0,0,0,.431-.006l4.365-3.2a.371.371,0,0,0,.135-.409l-1.338-4.308a19.664,19.664,0,0,0,3.3-5.45l4.441-.808a.371.371,0,0,0,.3-.309l.821-5.352a.371.371,0,0,0-.194-.385l-4-2.1a19.664,19.664,0,0,0-1.516-6.188l2.568-3.709a.371.371,0,0,0-.006-.431l-3.2-4.365a.371.371,0,0,0-.409-.135l-4.308,1.338a19.664,19.664,0,0,0-5.45-3.3l-.808-4.441a.371.371,0,0,0-.309-.3l-5.352-.821a.371.371,0,0,0-.384.194l-2.1,4a19.665,19.665,0,0,0-6.188,1.516l-3.709-2.568a.37.37,0,0,0-.43.006l-4.365,3.2a.371.371,0,0,0-.135.409l1.338,4.308a19.673,19.673,0,0,0-3.3,5.45l-4.441.808a.371.371,0,0,0-.3.309Z",
    transform: "translate(-808.005 -1596.715)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23594",
    "data-name": "Path 23594",
    d: "M1153.2,2003.178a5.155,5.155,0,1,1,3.982-1.871,5.134,5.134,0,0,1-3.982,1.871m.008-9.612a4.454,4.454,0,1,0,2.835,1.019,4.451,4.451,0,0,0-2.835-1.019",
    transform: "translate(-1071.856 -1860.604)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23595",
    "data-name": "Path 23595",
    d: "M1053.563,1895.323a13.6,13.6,0,0,1-2.062-.158,13.328,13.328,0,0,1-8.781-5.322,13.6,13.6,0,0,1-1.155-1.875h0l-.022-.044-.017-.035-.021-.042-.062-.128q-.082-.17-.159-.343l.639-.286a12.833,12.833,0,0,0,1.363,2.339,12.711,12.711,0,1,0-1.471-12.459l-.645-.271a13.415,13.415,0,1,1,12.4,18.623",
    transform: "translate(-972.068 -1744.478)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23596",
    "data-name": "Path 23596",
    d: "M1680.638,2295a.233.233,0,0,1-.2-.355c.166-.271.348-.536.539-.789a.233.233,0,1,1,.372.281c-.182.241-.355.494-.514.752a.233.233,0,0,1-.2.111",
    transform: "translate(-1568.88 -2141.527)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23597",
    "data-name": "Path 23597",
    d: "M1734.585,2240.739a.232.232,0,0,1-.2-.115,9.671,9.671,0,0,0-.732-1.075q-.149-.191-.306-.371a.233.233,0,0,1,.352-.306q.165.189.321.389a10.141,10.141,0,0,1,.767,1.127.233.233,0,0,1-.2.351m-14.077-3.021a.233.233,0,0,1-.136-.423,9.977,9.977,0,0,1,1.613-.938.233.233,0,1,1,.2.423,9.566,9.566,0,0,0-1.538.895.229.229,0,0,1-.135.044m10.761-.372a.231.231,0,0,1-.122-.034,9.458,9.458,0,0,0-1.6-.784.233.233,0,0,1,.165-.437,9.991,9.991,0,0,1,1.675.823.233.233,0,0,1-.122.432m-6.346-1.361a.234.234,0,0,1-.029-.465,10.084,10.084,0,0,1,1.865-.062.233.233,0,0,1-.028.466,9.586,9.586,0,0,0-1.778.06l-.03,0",
    transform: "translate(-1606.103 -2087.078)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23598",
    "data-name": "Path 23598",
    d: "M1949.173,2351.171a.233.233,0,0,1-.231-.2c-.038-.3-.091-.6-.158-.9a.233.233,0,1,1,.455-.1c.07.31.126.626.166.94a.234.234,0,0,1-.2.261.175.175,0,0,1-.03,0",
    transform: "translate(-1819.441 -2193.835)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23599",
    "data-name": "Path 23599",
    d: "M1915.07,2470.7a.234.234,0,0,1-.173-.39c.2-.224.4-.461.575-.705a.233.233,0,0,1,.376.277c-.189.256-.392.5-.6.74a.232.232,0,0,1-.173.077",
    transform: "translate(-1787.752 -2305.613)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23600",
    "data-name": "Path 23600",
    d: "M1683.944,2455.43a10.044,10.044,0,0,1-1.275-.082.233.233,0,1,1,.059-.463,9.576,9.576,0,0,0,1.748.063.237.237,0,0,1,.246.22.233.233,0,0,1-.22.246q-.279.015-.558.016m3.389-.608a.234.234,0,0,1-.081-.452,9.486,9.486,0,0,0,1.576-.759.233.233,0,0,1,.24.4,9.955,9.955,0,0,1-1.654.8.238.238,0,0,1-.081.015m-7.43-.264a.233.233,0,0,1-.1-.021,9.953,9.953,0,0,1-1.594-.909.233.233,0,0,1,.268-.382,9.473,9.473,0,0,0,1.518.866.233.233,0,0,1-.1.446m-3.659-2.892a.232.232,0,0,1-.184-.09,10.013,10.013,0,0,1-.99-1.545.233.233,0,1,1,.414-.215,9.559,9.559,0,0,0,.944,1.473.233.233,0,0,1-.184.377",
    transform: "translate(-1563.874 -2287.109)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23601",
    "data-name": "Path 23601",
    d: "M1659.51,2395.581a.233.233,0,0,1-.229-.192c-.055-.312-.1-.63-.122-.947a.233.233,0,0,1,.465-.038c.024.3.064.606.116.9a.233.233,0,0,1-.189.271.215.215,0,0,1-.041,0",
    transform: "translate(-1549.042 -2235.292)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23602",
    "data-name": "Path 23602",
    d: "M1696.342,2278.712a.117.117,0,0,0,.061.121l1.26.663a6.208,6.208,0,0,0,.478,1.952l-.81,1.169a.117.117,0,0,0,0,.136l1.011,1.377a.117.117,0,0,0,.129.042l1.359-.422a6.209,6.209,0,0,0,1.719,1.041l.255,1.4a.117.117,0,0,0,.1.094l1.688.259a.117.117,0,0,0,.121-.062l.663-1.26a6.211,6.211,0,0,0,1.951-.478l1.17.81a.117.117,0,0,0,.136,0l1.376-1.011a.116.116,0,0,0,.042-.129l-.422-1.358a6.2,6.2,0,0,0,1.041-1.719l1.4-.255a.117.117,0,0,0,.095-.1l.259-1.688a.117.117,0,0,0-.061-.122l-1.26-.663a6.2,6.2,0,0,0-.478-1.951l.81-1.17a.117.117,0,0,0,0-.136l-1.011-1.377a.116.116,0,0,0-.129-.042l-1.359.422a6.2,6.2,0,0,0-1.719-1.041l-.255-1.4a.118.118,0,0,0-.1-.095l-1.688-.258a.116.116,0,0,0-.121.061l-.663,1.26a6.2,6.2,0,0,0-1.951.478l-1.17-.81a.117.117,0,0,0-.136,0l-1.377,1.011a.117.117,0,0,0-.042.129l.422,1.359a6.213,6.213,0,0,0-1.041,1.719l-1.4.255a.117.117,0,0,0-.095.1Z",
    transform: "translate(-1583.758 -2120.71)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23603",
    "data-name": "Path 23603",
    d: "M1783.736,2360.727a1.865,1.865,0,1,1,1.441-.677,1.86,1.86,0,0,1-1.441.677m-.741-.966a1.167,1.167,0,1,0-.157-1.642,1.161,1.161,0,0,0,.157,1.642",
    transform: "translate(-1663.613 -2200.566)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23604",
    "data-name": "Path 23604",
    d: "M1752.56,2326.744a4.467,4.467,0,0,1-3.61-1.823l-.034-.047a4.5,4.5,0,0,1-.413-.705l-.007-.016-.005-.011,0,0-.018-.039.639-.286a3.792,3.792,0,0,0,.4.694l.045.06a3.771,3.771,0,0,0,5.208.761l.018-.013a3.747,3.747,0,0,0,1.5-2.469,3.8,3.8,0,0,0,.044-.579,3.772,3.772,0,0,0-7.247-1.456l-.645-.271a4.472,4.472,0,0,1,8.593,1.725,4.532,4.532,0,0,1-.053.687,4.465,4.465,0,0,1-4.413,3.791",
    transform: "translate(-1632.393 -2163.978)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23605",
    "data-name": "Path 23605",
    d: "M232.249,270.726s.523-21.976-9.6-27.858-29.368-9.559-30.089-41.115c-.422-18.474-.879-26.551-1.186-30.074a2.08,2.08,0,0,1,2.457-2.228c9.586,1.806,40.729,9.239,47.258,30.5,7.74,25.2-8.84,70.779-8.84,70.779",
    transform: "translate(-178.666 -158.171)",
    fill: "#bdd0fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12954",
    "data-name": "Group 12954",
    transform: "translate(21.901 19.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12953",
    "data-name": "Group 12953",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6561",
    "data-name": "Rectangle 6561",
    width: 91.867,
    height: 75.64,
    transform: "matrix(0.528, -0.85, 0.85, 0.528, -39.049, 62.08)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12956",
    "data-name": "Group 12956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12955",
    "data-name": "Group 12955",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23607",
    "data-name": "Path 23607",
    d: "M43.793,959.18c-.99-6.674-2.163-15.158-7.649-19.808-6.393-5.419-28.148-2-35.266-.7a1.067,1.067,0,0,0-.5,1.867C3.8,943.409,11.1,950.171,13,956.986c1.743,6.242,6.554,11.158,12.261,14.007,3.113,1.554,5.466,1.325,8.676,1.874,3.881.664,7.3,2.976,11.3,3.166a106.72,106.72,0,0,0-1.444-16.854",
    transform: "translate(0 -874.262)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23608",
    "data-name": "Path 23608",
    d: "M161.214,1027.722c9.082.38,18.83,4.523,23.777,12.294l.467.741a174.261,174.261,0,0,1,10.585,24.345.244.244,0,0,1-.155.308.249.249,0,0,1-.3-.146c-2.365-5.788-5.762-13.127-8.467-18.615-2.9-5.988-4.932-10.044-11.549-13.929a36.845,36.845,0,0,0-14.381-4.61.2.2,0,0,1,.028-.39",
    transform: "translate(-150.325 -959.514)",
    fill: "#bdd0fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12958",
    "data-name": "Group 12958",
    transform: "translate(17.116 113.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12957",
    "data-name": "Group 12957",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6563",
    "data-name": "Rectangle 6563",
    width: 69.415,
    height: 81.393,
    transform: "translate(-21.2 7.283) rotate(-18.961)",
    fill: "#1eb0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12960",
    "data-name": "Group 12960",
    transform: "translate(38.435 40.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12959",
    "data-name": "Group 12959",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6564",
    "data-name": "Rectangle 6564",
    width: 151.985,
    height: 148.159,
    transform: "matrix(0.872, -0.489, 0.489, 0.872, -44.901, 25.183)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12962",
    "data-name": "Group 12962",
    transform: "translate(142.753 39.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12961",
    "data-name": "Group 12961",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6565",
    "data-name": "Rectangle 6565",
    width: 56.872,
    height: 109.324,
    transform: "matrix(0.943, -0.334, 0.334, 0.943, -34.027, 12.045)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12964",
    "data-name": "Group 12964",
    transform: "translate(146.796 42.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12963",
    "data-name": "Group 12963",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6566",
    "data-name": "Rectangle 6566",
    width: 16.705,
    height: 101.544,
    transform: "translate(-1.078 0.011) rotate(-0.61)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12966",
    "data-name": "Group 12966",
    transform: "translate(146.796 75.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12965",
    "data-name": "Group 12965",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6567",
    "data-name": "Rectangle 6567",
    width: 35.727,
    height: 39.801,
    transform: "matrix(0.864, -0.504, 0.504, 0.864, -14.492, 8.463)",
    fill: "#1eb0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12968",
    "data-name": "Group 12968",
    transform: "translate(13.091 76.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12967",
    "data-name": "Group 12967",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6568",
    "data-name": "Rectangle 6568",
    width: 54.636,
    height: 55.982,
    transform: "matrix(0.759, -0.651, 0.651, 0.759, -23.296, 19.241)",
    fill: "#1eb0d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12976",
    "data-name": "Group 12976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12975",
    "data-name": "Group 12975",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23615",
    "data-name": "Path 23615",
    d: "M285.365,1258.814H267.387a1.639,1.639,0,0,1-1.376-2.53.462.462,0,1,1,.776.5.715.715,0,0,0,.6,1.1h17.978a.715.715,0,0,0,.715-.715V1255.9a.716.716,0,0,0-.715-.715H267.254a.462.462,0,0,1,0-.925h18.111a1.641,1.641,0,0,1,1.64,1.64v1.279a1.641,1.641,0,0,1-1.64,1.639",
    transform: "translate(-248.107 -1171.013)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23616",
    "data-name": "Path 23616",
    d: "M261.21,1378.782H243.232a1.64,1.64,0,0,1-1.376-2.53.462.462,0,0,1,.776.5.715.715,0,0,0,.6,1.1H261.21a.715.715,0,0,0,.715-.715v-1.279a.716.716,0,0,0-.715-.715H243.1a.462.462,0,0,1,0-.925H261.21a1.641,1.641,0,0,1,1.639,1.64v1.279a1.641,1.641,0,0,1-1.639,1.64",
    transform: "translate(-225.555 -1283.019)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12971",
    "data-name": "Group 12971",
    transform: "translate(57.337 48.473)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12970",
    "data-name": "Group 12970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12969",
    "data-name": "Group 12969",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23617",
    "data-name": "Path 23617",
    d: "M864.384,758.318a.462.462,0,0,1-.14-.9L949.2,730.381a.462.462,0,0,1,.28.881L864.524,758.3a.462.462,0,0,1-.14.022",
    transform: "translate(-863.922 -730.359)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12974",
    "data-name": "Group 12974",
    transform: "translate(45.848 78.415)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12973",
    "data-name": "Group 12973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12972",
    "data-name": "Group 12972",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23618",
    "data-name": "Path 23618",
    d: "M691.281,1184.234a.462.462,0,0,1-.175-.89l4.372-1.787a.462.462,0,1,1,.35.856l-4.372,1.787a.459.459,0,0,1-.175.034",
    transform: "translate(-690.819 -1181.522)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_23619",
    "data-name": "Path 23619",
    d: "M285.365,1519.284H267.387a1.64,1.64,0,0,1-1.376-2.53.462.462,0,1,1,.776.5.715.715,0,0,0,.6,1.1h17.978a.716.716,0,0,0,.715-.715v-1.279a.716.716,0,0,0-.715-.715H267.254a.462.462,0,1,1,0-.924h18.111a1.641,1.641,0,0,1,1.639,1.639v1.279a1.641,1.641,0,0,1-1.639,1.64",
    transform: "translate(-248.107 -1414.197)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23620",
    "data-name": "Path 23620",
    d: "M310.728,1675.234H292.75a1.64,1.64,0,0,1-1.376-2.53.462.462,0,1,1,.776.5.715.715,0,0,0,.6,1.1h17.978a.716.716,0,0,0,.715-.715v-1.279a.716.716,0,0,0-.715-.715H292.617a.462.462,0,0,1,0-.925h18.111a1.641,1.641,0,0,1,1.639,1.639v1.279a1.641,1.641,0,0,1-1.639,1.639",
    transform: "translate(-271.787 -1559.796)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23621",
    "data-name": "Path 23621",
    d: "M476.019,2032.36a11.725,11.725,0,0,1-2.5-.272,11.568,11.568,0,0,1-8.164-6.612l-14.363-31.91a.462.462,0,1,1,.843-.379L466.2,2025.1a10.653,10.653,0,0,0,7.518,6.088,10.435,10.435,0,0,0,9.184-2.348q.2-.178.409-.365a.462.462,0,1,1,.624.683q-.213.194-.423.378a11.315,11.315,0,0,1-7.489,2.827",
    transform: "translate(-421.021 -1860.649)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23622",
    "data-name": "Path 23622",
    d: "M396.872,1872.676a.462.462,0,0,1-.422-.272l-1.6-3.56a.462.462,0,1,1,.843-.38l1.6,3.56a.462.462,0,0,1-.421.652",
    transform: "translate(-368.605 -1744.203)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23623",
    "data-name": "Path 23623",
    d: "M2259.534,1191.86a.462.462,0,0,1-.461-.43c-.319-4.5-1.88-7.86-4.639-9.977-4.77-3.662-11.577-2.4-11.645-2.39a.462.462,0,1,1-.175-.908c.295-.057,7.287-1.348,12.383,2.565,2.977,2.286,4.659,5.868,5,10.646a.462.462,0,0,1-.428.494h-.033",
    transform: "translate(-2093.426 -1099.731)",
    fill: "#91b3fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12978",
    "data-name": "Group 12978",
    transform: "translate(163.295 109.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12977",
    "data-name": "Group 12977",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6572",
    "data-name": "Rectangle 6572",
    width: 24.681,
    height: 30.313,
    transform: "translate(-5.584 10.385) rotate(-61.734)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12980",
    "data-name": "Group 12980",
    transform: "translate(166.071 143.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12979",
    "data-name": "Group 12979",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6573",
    "data-name": "Rectangle 6573",
    width: 24.286,
    height: 25.586,
    transform: "matrix(0.835, -0.55, 0.55, 0.835, -9.318, 6.14)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12982",
    "data-name": "Group 12982",
    transform: "translate(167.952 37.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12981",
    "data-name": "Group 12981",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6574",
    "data-name": "Rectangle 6574",
    width: 35.569,
    height: 35.05,
    transform: "matrix(0.805, -0.594, 0.594, 0.805, -11.476, 8.469)",
    fill: "url(#linear-gradient-8)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.412cea155441981a4331914278214b44.svg";
export { ForwardRef as ReactComponent };